import { ControlledDot } from 'shared/ui/form/ControlledElements/ControlledDot'
import {
  ControlledIconButton
} from 'shared/ui/form/ControlledElements/ControlledIconButton'
import { addTestId } from 'shared/utils/tests'

import { TSelectOption } from '../types'

import styles from './ControlledOptionRow.module.scss'

interface ControlledOptionRowProps {
  type: 'colors' | 'icons'
  label
  defaultValue?: string
  name: string
  data: TSelectOption[]
  id?: string
}

export function ControlledOptionRow({
  type,
  label,
  name,
  data,
  id,
  defaultValue = ''
}: ControlledOptionRowProps) {
  return (
    <div id={id} className={styles.iconPicker}>
      {label}
      {data.map(el => {
        if (type === 'colors') {
          return (
            <ControlledDot
              defaultValue={defaultValue}
              key={el.value}
              name={name}
              value={el.value}
              {...addTestId(`${type}-${el.value}-dot`)}
            />
          )
        }

        if (type === 'icons') {
          return (
            <ControlledIconButton
              defaultValue={defaultValue}
              key={el.value}
              name={name}
              value={el.value}
              type='button'
              {...addTestId(`${type}-${el.value}-icon-button`)}
            />
          )
        }

        return null
      })}
    </div>
  )
}
